import { Spinner, Text, useUpdateEffect } from '@chakra-ui/react';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import IncomeChartLoaded from 'presentation/components/modules/incomeChart/IncomeChartLoaded';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppRoute from 'router/AppRoute';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import {
  useFetchHomeQuery,
  useLazyFetchHomeChartQuery,
} from 'rtkQuery/sharespro/queries/home';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import useFilterChartData from 'hooks/modules/chart/userFilterChart';

const HomeChartContainer: FC = () => {
  const [period, setPeriod] = usePeriodQueryParam();
  const [accountId] = useAccountIdQueryParam();
  const { data, error, refetch, isFetching } = useFetchHomeQuery({
    period,
    account_id: accountId,
  });
  const [trigger, chartResult] = useLazyFetchHomeChartQuery();

  useUpdateEffect(() => {
    trigger({ period, account_id: accountId });
  }, [period]);

  const filterChartData = useFilterChartData;

  const { t } = useTranslation();

  let content;
  if (data) {
    const filteredChartData = filterChartData(data.chart.chartData);
    if (filteredChartData.length > 1) {
      content = (
        <IncomeChartLoaded
          data={{ ...data.chart, chartData: filteredChartData }}
          onPeriodClick={(period) => setPeriod(period)}
          isDataFetching={chartResult.isFetching || isFetching}
          selectedPeriod={period}
          onRefetch={() => {
            refetch();
          }}
          error={error}
          period={period}
        />
      );
    } else {
      content = <Text textAlign="center">{t('chartDataIsPreparing')}</Text>;
    }
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  return (
    <>
      <GridHeading
        trailingLink={{
          path: AppRoute.portfolio,
          text: t('moreDetails'),
        }}
      >
        {t('incomeChartTitle')}
      </GridHeading>
      <AppCard
        p="20px"
        minH="320px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {content}
      </AppCard>
    </>
  );
};

export default HomeChartContainer;
